import { useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tone } from "@/components/shared";
import { useAuth } from "@/lib/auth";
import { can } from "@/lib/roles";
import { api, errMsg, fdt, useApi } from "@/lib/api";

export function ShopifySyncBar({ onSynced }) {
  const { user } = useAuth();
  const { data, reload } = useApi("/integrations/shopify/status");
  const [busy, setBusy] = useState(false);
  const last = data?.recentRuns?.[0];
  const sync = async () => {
    setBusy(true);
    try {
      const r = await api.post("/inventory/shopify-sync");
      toast.success(`Shopify sync complete — ${r.data.productsPushed} products pushed, ${r.data.ordersPulled} new orders pulled`);
      onSynced?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); reload(); }
  };
  if (!data) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto" data-testid="shopify-sync-bar">
      <div className="text-left sm:text-right min-w-0">
        <div className="flex flex-wrap items-center gap-1.5 sm:justify-end">
          {data.mode === "live" ? <Tone tone="green" data-testid="shopify-mode">Live · {data.storeDomain}</Tone> : <Tone tone="amber" data-testid="shopify-mode">Demo mode (MOCKED)</Tone>}
          {last && <Tone tone={last.status === "SUCCESS" ? "gray" : "red"}>{last.status === "SUCCESS" ? "Last sync OK" : "Last sync failed"}</Tone>}
        </div>
        <div className="text-[11px] text-muted-foreground mt-1" data-testid="shopify-last-sync">
          Auto-sync every {data.autoSyncEvery}{last && ` · last ${last.trigger} ${fdt(last.finishedAt)}`}
        </div>
      </div>
      {can(user, "shopify:sync") && (
        <Button variant="outline" onClick={sync} disabled={busy} data-testid="shopify-sync-button">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <RefreshCw className="h-4 w-4 mr-2" />}Sync now
        </Button>
      )}
    </div>
  );
}
